import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ResourceCard, SectionHeading } from "@/components/ResourceCard";

export const CategoryResources = ({ category, title, overline, subtitle, categoryName }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/resources", { params: { category } }).then((r) => setItems(r.data)).catch(() => {});
  }, [category]);
  if (items.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
      <SectionHeading overline={overline} title={title} subtitle={subtitle} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {items.map((r) => <ResourceCard key={r.id} r={r} categoryName={categoryName} />)}
      </div>
    </section>
  );
};
